/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { Button } from '@zapier/design-system';
const Styles = {
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
};
/**
 * Renders the button to advance to the next form stage.
 */
const NextButton = ({ disabled = false, onClick }) => (isolateComponent("div", { css: Styles.root },
    isolateComponent(Button, { disabled: disabled, onClick: onClick }, "Next")));
export default NextButton;
